var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_1131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_1131)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 25.8125C29 27.5729 27.5729 29 25.8125 29H15.1875C13.4271 29 12 27.5729 12 25.8125V15.1875C12 13.4271 13.4271 12 15.1875 12H25.8125C27.5729 12 29 13.4271 29 15.1875V25.8125ZM23.043 24.168C21.3536 22.8611 19.08 22.8611 17.3906 24.168C17.0509 24.4337 16.9874 24.9327 17.2529 25.2832C17.5186 25.6231 18.0175 25.6865 18.3682 25.4209C19.4943 24.5498 20.95 24.5499 22.0762 25.4209C22.2249 25.5378 22.3954 25.5908 22.5654 25.5908C22.8097 25.5908 23.0436 25.485 23.1816 25.2832C23.4578 24.9326 23.3936 24.4336 23.043 24.168ZM25.3818 20.8848C22.2475 18.4623 18.1881 18.4623 15.0537 20.8848C14.7139 21.1504 14.6504 21.6504 14.916 22.001C15.1816 22.3407 15.6807 22.404 16.0312 22.1387C18.5813 20.173 21.865 20.173 24.415 22.1387C24.5637 22.2554 24.7334 22.3085 24.9033 22.3086C25.1475 22.3086 25.3814 22.2026 25.5195 22.001C25.7958 21.6504 25.7325 21.1504 25.3818 20.8848ZM27.0928 17.6016C22.9173 14.3823 17.5302 14.3825 13.3652 17.6016C13.0253 17.8672 12.961 18.3672 13.2266 18.7178C13.4922 19.0578 13.9921 19.1211 14.3428 18.8555C17.9127 16.0932 22.5347 16.093 26.1152 18.8555C26.2639 18.9723 26.4336 19.0254 26.6035 19.0254C26.8372 19.0254 27.0817 18.9196 27.2305 18.7178C27.5067 18.3671 27.4434 17.8672 27.0928 17.6016Z",
    fill: "#34D399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_1131",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_1131",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.434d889337c98d474a460d5248940530.svg";
export { ForwardRef as ReactComponent };